import React from 'react';

import { ExtratoFppListComp } from './components';

import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function ExtratoFppList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['FINANCEIRO_EXTRATO_FPP_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <ExtratoFppListComp />
        </ListagemProvider>
    );
}
